import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationCancel, NavigationEnd, NavigationError, Router, RouterOutlet } from '@angular/router';
import { filter, map, take } from 'rxjs';
import { InitialLoadingComponent } from './features/order-to-seat/shared/initial-loading/initial-loading.component';

@Component({
  selector: 'ots-root',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet, InitialLoadingComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  host: { class: 'd-block full-width full-height' }
})
export class App {

  private readonly _router = inject(Router);

  protected readonly initialLoading = toSignal(
    this._router.events.pipe(
      filter(event =>
        event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError
      ),
      take(1),
      map(() => false)
    ),
    { initialValue: true }
  );
}
